import { useRef } from "react";
import { FiChevronLeft, FiChevronRight } from "react-icons/fi";
import ContentCard from "./ContentCard";

export default function ContentRow({ title, items, type, onSeeAll }) {
  const rowRef = useRef(null);

  const scroll = (dir) => {
    if (!rowRef.current) return;
    const amount = rowRef.current.offsetWidth * 0.75;
    rowRef.current.scrollBy({ left: dir === "left" ? -amount : amount, behavior: "smooth" });
  };

  if (!items?.length) return null;

  return (
    <div className="mb-10">
      {/* Header */}
      <div className="flex items-center justify-between mb-4 px-5 md:px-10">
        <h2 className="text-lg md:text-xl font-bold text-white">{title}</h2>
        {onSeeAll && (
          <button onClick={onSeeAll} className="text-sm text-primary hover:text-primary-hover font-medium transition-colors">
            See All &rsaquo;
          </button>
        )}
      </div>

      {/* Scrollable Row */}
      <div className="relative group/row">
        {/* Left Arrow */}
        <button
          onClick={() => scroll("left")}
          className="absolute left-0 top-0 bottom-0 w-10 z-10 flex items-center justify-center bg-gradient-to-r from-dark-900/80 to-transparent opacity-0 group-hover/row:opacity-100 transition-opacity"
        >
          <FiChevronLeft size={24} className="text-white" />
        </button>

        <div
          ref={rowRef}
          className="flex gap-3 md:gap-4 overflow-x-auto px-5 md:px-10 pb-4 scrollbar-hide scroll-smooth"
          style={{ scrollbarWidth: "none", msOverflowStyle: "none" }}
        >
          {items.map((item, index) => (
            <ContentCard key={`${item.id || item.slug || item.title || item.name || "item"}-${index}`} item={item} type={type} />
          ))}
        </div>

        {/* Right Arrow */}
        <button
          onClick={() => scroll("right")}
          className="absolute right-0 top-0 bottom-0 w-10 z-10 flex items-center justify-center bg-gradient-to-l from-dark-900/80 to-transparent opacity-0 group-hover/row:opacity-100 transition-opacity"
        >
          <FiChevronRight size={24} className="text-white" />
        </button>
      </div>
    </div>
  );
}
